// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"dbc16eee","161":"c4dc9eb1","274":"9f6f9952","375":"7c4dad5f","393":"dee7981f","603":"2b4e2ff8","608":"45c8eae1","638":"3107ecff","851":"09190637","903":"5ffe35b6","963":"938586dd"}[chunkId] + ".chunk.js";
};